import { render, staticRenderFns } from "./forward-dialog.vue?vue&type=template&id=4fe02d71"
import script from "./forward-dialog.vue?vue&type=script&lang=js"
export * from "./forward-dialog.vue?vue&type=script&lang=js"
import style0 from "./forward-dialog.vue?vue&type=style&index=0&id=4fe02d71&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/LRL_LCDDMAC_eMSL_CFC/LRL_LCDDMAC_eMSL_CFC/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fe02d71')) {
      api.createRecord('4fe02d71', component.options)
    } else {
      api.reload('4fe02d71', component.options)
    }
    module.hot.accept("./forward-dialog.vue?vue&type=template&id=4fe02d71", function () {
      api.rerender('4fe02d71', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/commons/forward-dialog.vue"
export default component.exports